module.exports = __webpack_public_path__ + "img/specialization.8bb5d249.jpg";